import { render, staticRenderFns } from "./VegetativeMonitoringEnviroDataDetails.vue?vue&type=template&id=89ede006"
import script from "./VegetativeMonitoringEnviroDataDetails.vue?vue&type=script&lang=js"
export * from "./VegetativeMonitoringEnviroDataDetails.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports